import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, LinearProgress, Slide } from '@material-ui/core';
import error from '../../assets/img/error-system.svg';
import success from '../../assets/img/tick-outline-hi-dark.svg';
import './notification.scss';

Notifs.propTypes = {
    variant: PropTypes.string,
    position: PropTypes.number,
    closeNotif: PropTypes.func
}

function Notifs({ text, variant = 'message', position = 'top-left', showProgress = true, closeNotif = null, showCloseBtn = false }) {
    const [progress, setProgress] = useState(0);
    useEffect(() => {
        let mounted = true;
        if (progress < 100) {
            setTimeout(() => mounted && setProgress(progress + Math.floor(Math.ceil(Math.random() * 15))), 1000);
        } else {
            setProgress(0);
        }
        return function cleanUp() {
            mounted = false;
        }
    });

    return (
        <>
            <Slide direction={'right'} in={true} timeout={330}>
                <div className={`card height10 width35 ${variant} ${position}`}>
                    <div className={'flex-row'}>
                        {variant !== 'message' && <img src={variant === 'success' ? success : error} className={'height32 width32'}></img>}
                        <div className={'flex-column'}>
                            <article>{text}</article>
                            {showProgress && <LinearProgress variant="determinate" value={progress} className={'progress'} />}
                        </div>
                        {showCloseBtn &&
                            <CloseButton closeAction={closeNotif} />}
                    </div>
                </div>
            </Slide>
        </>
    )
}

function CloseButton({ closeAction }) {
    return (
        <>
            <Button
                className={'height24 width24 top right absolute close-btn'}
                variant={'contained'}
                onClick={closeAction}>X</Button>
        </>
    )
}

export default Notifs;